import { ApiClientReturnType } from '~/types';
import api from '../http-common';

const getOptionsData = (signal?: AbortSignal) =>
  api.post('/settings/pop-ups/get-options-data', {}, { signal });

const createLoginPopup = (data) =>
  api.post('/settings/pop-ups/store', data)

const getLoginPopupsList = (signal?: AbortSignal) =>
  api.post('/settings/pop-ups/index', {}, { signal })

const getLoginPopup = (id: string, signal?: AbortSignal) =>
  api.post(`/settings/pop-ups/${id}/edit`, {}, { signal })

const updateLoginPopup = (id, data) =>
  api.post(`/settings/pop-ups/${id}/update`, data)

const showLoginPopup = (id) =>
  api.post(`/settings/pop-ups/${id}/show`)

const deleteLoginPopup = (id) =>
  api.post(`/settings/pop-ups/${id}/delete`)

const getFileUrl = (id, data?) =>
  api.post(`/settings/pop-ups/${id}/get-file-url`, data)

/// Farmer login popups

const getFarmerLoginPopups = ():ApiClientReturnType<LoginPopups> =>
  api.post('/pop-ups/get-data')

const enableLoginPopups = () =>
  api.post('/pop-ups/enable-on-login')

const disableLoginPopups = () =>
  api.post('/pop-ups/disable-on-login')

const getFarmerLoginPopupUrl = (id: string, data?) =>
  api.post(`/pop-ups/${id}/get-file-url`, data)

const getChangeDataPopupData = (id: string, signal?: AbortSignal):ApiClientReturnType<ChangePopupData> =>
  api.post(`/pop-ups/${id}/get-data`, {}, { signal })

const confirmChangeDataPopup = (id: string, data):ApiClientReturnType<void> =>
  api.post(`/pop-ups/${id}/confirm`, data)

const closeChangeDataPopup = (id: string):ApiClientReturnType<void> =>
  api.post(`/pop-ups/${id}/close`)

export const LoginPopupsService = {
  getOptionsData,
  createLoginPopup,
  getFileUrl,
  getLoginPopup,
  updateLoginPopup,
  showLoginPopup,
  deleteLoginPopup,
  getLoginPopupsList,
  getFarmerLoginPopups,
  getFarmerLoginPopupUrl,
  getChangeDataPopupData,
  enableLoginPopups,
  confirmChangeDataPopup,
  closeChangeDataPopup,
  disableLoginPopups
}

export interface LoginPopups {
  infoPopUps: PopUp[];
  changeDataPopUps: PopUp[];
}

export interface PopUp {
  id: string;
  type: number;
  from: string;
  to: string;
  farmerGroups: any[];
  roles: number[];
  typeLabel: string;
  userId?: string;
  popUpId: string;
  completed?: number;
  completedAt?: null;
  code: string;
  icon: string;
  title: string;
  headerText: string;
  content: null | string;
  footerText: string;
  label: string;
  languageId: number;
  fields?: Field[];
  status?: number;
  downloadEnabled?: number;
}

export interface Field {
  id: number;
  popUpId: string;
  slug: string;
  category: Category;
  required: number;
  action: number;
  order: number;
}

export enum Category {
  UserData = 'user_data',
  ManagerData = 'manager_data',
  FarmerData = 'farmer_data'
}

export interface ChangePopupData {
  id: string;
  birthDate?: string;
  managerId: string;
  firstName: string;
  lastName: string;
  email: string;
  languageLabel: string;
  profile: Profile;
  manager: Manager;
}

export interface Manager {
  id: string;
  agisId: string;
  firstName: null;
  lastName: null;
  financialSettings: any[];
  address: Address;
  farmers: Farmer[];
}

export interface Address {
  addressableId: string;
  streetName: string;
  streetNumber: string;
  zip: string;
  city: string;
  cantonId: number | null;
  countryId: number;
}

export interface Farmer {
  id: string;
  agisId: string;
  evsNumber: string;
  companyName: string;
  managerId: string;
  farmerId: string;
  address: Address;
  contacts: Contact[];
}

export interface Contact {
  farmerId: string;
}

export interface Profile {
  mobilePrefix: number;
  mobileNumber: string;
}

export type FinancialSetting = {
  // add fields when API returns data
};

export type User = {
  id: string;
  managerId: string;
  firstName: string;
  lastName: string;
  email: string;
  languageLabel: string;
  profile: Profile;
  manager: Manager;
};